import React from 'react'

import { Text, TextName } from 'sdk'
import { ImageTextBlockNew } from 'components/image-text-block-new/ImageTextBlockNew'

import styles from './FeaturesSection.module.scss'

interface FeatureBlock {
  imageDesktop: string
  imageMobile: string
  title: string
  pillIcon: string
  pillText: string
  reverse?: boolean
  content: {
    heading: string
    items: string[]
  }
}

interface FeaturesSectionProps {
  title: string
  features: FeatureBlock[]
}

export const FeaturesSection: React.FC<FeaturesSectionProps> = ({ title, features }) => {
  return (
    <section className={styles.wrapper}>
      <Text type={TextName.H2} className={styles.h2}>
        {title}
      </Text>
      <div className={styles.featuresSection}>
        {features.map(({ imageDesktop, imageMobile, title, pillIcon, pillText, reverse, content }, index) => (
          <ImageTextBlockNew
            key={index}
            imageDesktop={imageDesktop}
            imageMobile={imageMobile}
            title={title}
            pillIcon={pillIcon}
            pillText={pillText}
            reverse={reverse}
          >
            <Text type={TextName.TextBold}>
              {content.heading}
            </Text>
            <ul>
              {content.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <Text type={TextName.Text}>{item}</Text>
                </li>
              ))}
            </ul>
          </ImageTextBlockNew>
        ))}
      </div>
    </section>
  )
}
